import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { LoaderModule } from 'libraries/component/loader/loader.module';
import { NotificationModule } from 'libraries/component/notification/notification.module';
import { CardModule } from 'libraries/ui_card/card.module';
import { BookingResourceModule } from 'libraries/service/resources/booking/bookingResource.module';
import { IqbaRedirectionModule } from 'libraries/service/resources/redirection/IQBA/iqba-redirection.module';
import {
    BookingTechnicalInformationsModule
} from './components/booking-technical-informations/booking-technical-informations.module';
import { BookingMainInformationsModule } from './components/booking-main-informations/booking-main-informations.module';
import { MenuModule } from './components/menu/menu.module';
import { SectorsModule } from './components/sectors/sectors.module';
import { ConfigurationResourceModule } from 'libraries/service/resources/configuration/configurationResource.module';
import { EnumsResourceModule } from 'libraries/service/booking/enums/enums-resource.module';
import {
    TableServicesServiceModule
} from './components/sectors/components/shared/services/table-services/table-services.module';
import { BookingTravellerCardModule } from "./components/booking-traveller-card/booking-traveller-card.module";
import { BookingContactsModule } from './components/booking-contacts/booking-contacts.module';
import { BookingRemarksModule } from './components/booking-remarks/booking-remarks.module';
import { QualityCheckResultModule } from "libraries/component/quality-check-result/quality-check-result.module";
import { BookingInformationComponent } from './booking-information.component';
import { BookingOperationsComponent } from './components/booking-operations/booking-operations.component';
import { BookingServicesComponent } from './components/booking-services/booking-services.component';
import { DatePipeModule } from "libraries/date/date.module";
import { MultiselectModule } from "libraries/module/formbuilder/fields/multiselect/multiselect.module";
import { TextWithChildrenComponent } from './components/text-with-children/text-with-children.component';
import { UIModule } from "libraries/ui/ui.module";
import { BookingOperationService } from "libraries/component/booking-information/services/booking-operation.service";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatTableModule } from "@angular/material/table";
import { MatRippleModule } from "@angular/material/core";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { IconNameToDefinitionModule } from "../../pipes/icon-name-to-definition/icon-name-to-definition.module";
import { PermissionModule } from "libraries/permission/permission.module";
import { BookingFareOptHistoryComponent } from './components/booking-fare-opt-history/booking-fare-opt-history.component';
import { IframeAppEmbedderModule } from "libraries/component/iframe-app-embedder/iframe-app-embedder.module";
import {
    AncillaryServicesListModule
} from "libraries/component/ancillary-services-list/ancillary-services-list.module";
import { VehicleRentalStepModule } from "./components/vehicle-rental-step/vehicle-rental-step.module";
import { BookingQualityControlModule } from "./components/booking-quality-control/booking-quality-control.module";
import {
    BookingOperationResultIconModule
} from "libraries/component/booking-information/components/booking-operation-result-icon/booking-operation-result-icon.module";
import { BookingAddServicesService } from "./services/booking-add-services.service";
import { AirServicesResourceModule } from "../../service/resources/air-services-resource/air-services-resource.module";
import {
    BookingAncillaryServicesPageComponent
} from './components/booking-ancillary-services-page/booking-ancillary-services-page.component';
import { AncillaryServicesSummaryModule } from "../ancillary-services-summary/ancillary-services-summary.module";
import { BookingQualityControlDataModule } from "../booking-quality-control-data/booking-quality-control-data.module";
import { SafeHtmlPipeModule } from "libraries/pipes/safeHtml/safeHtml.module";
import {
    BookingPriceCardModule
} from "libraries/component/booking-information/components/booking-price-card/booking-price-card.module";
import { MenuDetailsModule } from "libraries/hotel/components/menu-details/menu-details.module";
import {
    BookingFareOptimisationCardModule
} from "libraries/component/booking-information/components/booking-fare-optimisation-card/booking-fare-optimisation-card.module";
import { AirBookingResourceModule } from "libraries/service/resources/air-booking/air-booking-resource.module";


@NgModule({
    imports: [
        AirBookingResourceModule,
        BookingContactsModule,
        BookingMainInformationsModule,
        BookingPriceCardModule,
        BookingRemarksModule,
        BookingResourceModule,
        IqbaRedirectionModule,
        BookingTechnicalInformationsModule,
        BookingTravellerCardModule,
        CardModule,
        CommonModule,
        ConfigurationResourceModule,
        DatePipeModule,
        EnumsResourceModule,
        LoaderModule,
        MatRippleModule,
        MatSidenavModule,
        MatTableModule,
        DatePipeModule,
        MenuModule,
        MultiselectModule,
        NotificationModule,
        PermissionModule,
        QualityCheckResultModule,
        ReactiveFormsModule,
        SectorsModule,
        TableServicesServiceModule,
        UIModule,
        FontAwesomeModule,
        IconNameToDefinitionModule,
        AirBookingResourceModule,
        IframeAppEmbedderModule,
        AncillaryServicesListModule,
        VehicleRentalStepModule,
        AirServicesResourceModule,
        BookingQualityControlModule,
        BookingOperationResultIconModule,
        BookingQualityControlDataModule,
        AncillaryServicesSummaryModule,
        SafeHtmlPipeModule,
        MenuDetailsModule,
        BookingFareOptimisationCardModule,
    ],
    exports: [
        BookingInformationComponent,
    ],
    declarations: [
        BookingInformationComponent,
        BookingOperationsComponent,
        BookingServicesComponent,
        TextWithChildrenComponent,
        BookingFareOptHistoryComponent,
        BookingAncillaryServicesPageComponent,
    ],
    providers: [
        BookingOperationService,
        BookingAddServicesService,
    ]
})
export class BookingInformationModule {
}
